module.exports = __webpack_public_path__ + "img/img_1.dd8e451b.png";